import createIcon from '../../createIcon';

/**
 * @component @name Hive
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuNzg5OSA4TDE1LjU4OTkgNUwxMy43ODk5IDJIMTAuMjA5OUw4LjQwOTkyIDVMMTAuMjA5OSA4SDEzLjc4OTlaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTAuMjA5OSA5TDguNDA5OTIgMTJMMTAuMjA5OSAxNUgxMy43ODk5TDE1LjU4OTkgMTJMMTMuNzg5OSA5SDEwLjIwOTlaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTYuNDQ5OSAxMS41MUgyMC4wMzk5TDIxLjgyOTkgOC41MUwyMC4wMzk5IDUuNTFIMTYuNDQ5OUwxNC42NDk5IDguNTFMMTYuNDQ5OSAxMS41MVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMC4wMzk5IDEyLjUxSDE2LjQ0OTlMMTQuNjQ5OSAxNS41MUwxNi40NDk5IDE4LjUxSDIwLjAzOTlMMjEuODI5OSAxNS41MUwyMC4wMzk5IDEyLjUxWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTcuNTQ5OTIgMTEuNTFMOS4zNDk5MiA4LjUxTDcuNTQ5OTIgNS41MUgzLjk1OTkyTDIuMTY5OTIgOC41MUwzLjk1OTkyIDExLjUxSDcuNTQ5OTJaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNy41NDk5MiAxMi41MUgzLjk1OTkyTDIuMTY5OTIgMTUuNTFMMy45NTk5MiAxOC41MUg3LjU0OTkyTDkuMzQ5OTIgMTUuNTFMNy41NDk5MiAxMi41MVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMC4yMDk5IDE2TDguNDA5OTIgMTlMMTAuMjA5OSAyMkgxMy43ODk5TDE1LjU4OTkgMTlMMTMuNzg5OSAxNkgxMC4yMDk5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Hive = createIcon('Hive', [
  [
    'path',
    { d: 'M13.7899 8L15.5899 5L13.7899 2H10.2099L8.40992 5L10.2099 8H13.7899Z', key: '116vda' },
  ],
  [
    'path',
    { d: 'M10.2099 9L8.40992 12L10.2099 15H13.7899L15.5899 12L13.7899 9H10.2099Z', key: '1b6194' },
  ],
  [
    'path',
    {
      d: 'M16.4499 11.51H20.0399L21.8299 8.51L20.0399 5.51H16.4499L14.6499 8.51L16.4499 11.51Z',
      key: 'ofowa3',
    },
  ],
  [
    'path',
    {
      d: 'M20.0399 12.51H16.4499L14.6499 15.51L16.4499 18.51H20.0399L21.8299 15.51L20.0399 12.51Z',
      key: '1tsm0n',
    },
  ],
  [
    'path',
    {
      d: 'M7.54992 11.51L9.34992 8.51L7.54992 5.51H3.95992L2.16992 8.51L3.95992 11.51H7.54992Z',
      key: '1l97fc',
    },
  ],
  [
    'path',
    {
      d: 'M7.54992 12.51H3.95992L2.16992 15.51L3.95992 18.51H7.54992L9.34992 15.51L7.54992 12.51Z',
      key: '1dt3p4',
    },
  ],
  [
    'path',
    {
      d: 'M10.2099 16L8.40992 19L10.2099 22H13.7899L15.5899 19L13.7899 16H10.2099Z',
      key: '2h1h6h',
    },
  ],
]);

export default Hive;
